import React, { useState } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { Field, Form } from "react-jsonschema-form-validation";
import { setupData } from "../../../configs/routes";
import * as userService from "../../../services/userService";
import * as dateService from "../../../services/dateService";
import { pathRoot } from "../Consent";

export function Page2({ consentSettings, onSaveFailure }) {
	let loadedDate = null;

	if (
		consentSettings.consentAccepted === null ||
		consentSettings.consentAccepted === undefined
	) {
		loadedDate = new Date();
	} else {
		loadedDate = dateService.getDateFromEpoch(consentSettings.consentAccepted);
	}

	const [consent, setConsent] = useState(consentSettings.consent ?? null);
	const [date] = useState(loadedDate);

	const schema = {
		type: "object",
	};

	const radioHandler = (value) => {
		setConsent(value);
	};
	const onFinish = () => {
		return new Promise((resolve, reject) => {
			consentSettings.consent = consent;

			if (consent) {
				consentSettings.consentAccepted = dateService.getEpochTime(date);
			} else {
				consentSettings.consentAccepted = null;
			}

			consentSettings.complete = true;

			userService
				.saveConsent(consentSettings)
				.then(resolve)
				.catch((error) => onSaveFailure(error));
		});
	};

	const headerDetails = {
		title: "Consent",
		currentPage: 2,
		pageCount: 2,
	};

	return (
		<SetupDataPageTemplate
			headerDetails={headerDetails}
			backTo={`${pathRoot}/1`}
			nextTo={setupData}
			hideNext={consent === null}
			onClickNext={{ func: onFinish, async: true }}
			nextTextOverride={"Finish"}
		>
			<Form schema={schema}>
				<h2 className={"text-lg sm:text-xl font-bold mb-1 sm:mb-2"}>
					Do you consent to us using your data?
				</h2>
				<p className={"text-sm lg:text-base mb-8"}>
					If you change your consent from yes to no, we will no longer use your
					data from this point forward for audit or research.
				</p>

				<div className={`radioSlider`}>
					<Field
						type="radio"
						name="consent"
						id="yes"
						className={"hidden radioOption"}
						value={"yes"}
						checked={consent === true ? "checked" : null}
						onClick={(e) => radioHandler(true)}
					/>
					<label
						htmlFor={"yes"}
						className={`option ${
							consent ? `bg-black text-white font-medium` : "bg-gray-100"
						}`}
					>
						Yes
					</label>

					<Field
						type="radio"
						name="consent"
						id="no"
						className={"hidden radioOption"}
						value={"no"}
						checked={consent === false ? "checked" : null}
						onClick={(e) => radioHandler(false)}
					/>
					<label
						htmlFor={"no"}
						className={`option ${
							!consent ? `bg-black text-white font-medium` : "bg-gray-100"
						}`}
					>
						No
					</label>
				</div>

				{consent === true && (
					<>
						<p className="mt-8 text-sm">
							Consent provided:{" "}
							<span className={"font-bold"}>
								{dateService.getDayAbbreviation(date.getDay())} {date.getDate()}
								<sup>{dateService.getDateOrdinal(date.getDate())}</sup>{" "}
								{dateService.getMonthAbbreviation(date.getMonth())}{" "}
								{date.getFullYear()}
							</span>
						</p>
					</>
				)}
				{consent === false && (
					<p className={"text-sm mt-8 sm:mb-6 leading-tight"}>
						Select "No" if you want to change your mind. Someone will be in
						touch. We will not use your data until you select yes.
					</p>
				)}
			</Form>
		</SetupDataPageTemplate>
	);
}
